<template>
  <flow-command :name="command">
    <div class="item">
      <span class='material-icons-round'> {{ icon }} </span>
      <span>{{ label }}</span>
    </div>
  </flow-command>
</template>

<script>
import { Command } from 'vg-editor';

export default {
  name: 'FlowMenuListItem',

  props: ['command', 'icon', 'text'],

  computed: {
    label() {
      return this.text || this.command;
    },
  },
  components: {
    FlowCommand: Command,
  },
};
</script>

<style lang='scss' scoped>
.item {
  display: flex;
  span {
    margin-left: 5px;
    &.material-icons-round {
      margin-top: 5px;
      font-size: 14px;
    }
  }
}
</style>
